import {getTypeaheadNodeTableContext} from 'components/DSYS/editor/nodes/TypeaheadNode';

export function getRootWorkstreamIdFromValue(value: unknown): number | undefined {
  if (typeof value === 'number' && value > 0) {
    return value;
  }
  if (value && typeof value === 'object' && 'v' in value) {
    const v = (value as {v: unknown}).v;
    if (typeof v === 'number' && v > 0) {
      return v;
    }
  }
  return undefined;
}

export function resolveSwitchboardTableEmbedRootId(
  switchboardId: number,
  switchboardSubWorkstreamIds: number[],
  tableContext: ReturnType<typeof getTypeaheadNodeTableContext>
): number {
  const isRepeatedSubworkstreamTable =
    !!tableContext &&
    tableContext.bodyRowCount > 0 &&
    tableContext.workstreamNameNodeCount === tableContext.bodyRowCount;
  const repeatedTableRowIndex =
    isRepeatedSubworkstreamTable &&
    tableContext.rowIndex !== null &&
    tableContext.rowIndex !== -1 &&
    tableContext.rowIndex >= 0
      ? tableContext.rowIndex
      : undefined;

  if (repeatedTableRowIndex !== undefined) {
    const subId = switchboardSubWorkstreamIds[repeatedTableRowIndex];
    if (subId !== undefined) return subId;
  }
  return switchboardId;
}
